import React from 'react';
import { withRouter } from 'react-router-dom';
import Nav from 'react-bootstrap/Nav';
import { faHome, faFile, faComment, faFolder, faUser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Logo from "../../../assets/images/logo-w.svg";

import '../../../assets/css/sb-admin-2.min.css';

function MenuSider(props) {
    const { location } = props;

    return (
        <>
            <Nav defaultActiveKey={[location.pathname]} className="navbar-nav bg-gradient-primary sidebar sidebar-dark accordion">
                <Nav.Item  className="nav-item" >
                    <Nav.Link eventKey="/admin" href="/admin" className="sidebar-brand d-flex align-items-center justify-content-center">
                        <img src={Logo} width="100%" alt="" />
                    </Nav.Link>
                </Nav.Item>
                <hr className="sidebar-divider my-0" />
                <Nav.Item className="nav-item" >
                    <Nav.Link eventKey="/admin" href="/admin" className="nav-link" >
                        <FontAwesomeIcon className="fas fa-home" icon={faHome} />
                        <span> Home</span>
                    </Nav.Link>
                </Nav.Item>
                <hr className="sidebar-divider" />
                <Nav.Item className="nav-item" >
                    <Nav.Link eventKey="/admin/publication" href="/admin/publication" className="nav-link">
                        <FontAwesomeIcon className="fas fa-file" icon={faFile} />
                        <span> Todas las Publicaciones</span>
                    </Nav.Link>
                </Nav.Item>
                <Nav.Item className="nav-item">
                    <Nav.Link eventKey="/admin/new_publication" href="/admin/new_publication" className="nav-link" >
                        <FontAwesomeIcon className="fas fa-file" icon={faFile} />
                        <span> Nueva Publicación</span>
                    </Nav.Link>
                </Nav.Item>
                <hr className="sidebar-divider" />
                <Nav.Item className="nav-item" >
                    <Nav.Link eventKey="/admin/comment" href="/admin/comment" className="nav-link" >
                        <FontAwesomeIcon className="fas fa-comment" icon={faComment} />
                        <span> Comentarios</span>
                    </Nav.Link>
                </Nav.Item>
                <Nav.Item className="nav-item">
                    <Nav.Link eventKey="/admin/subcategory" href="/admin/subcategory" className="nav-link">
                        <FontAwesomeIcon className="fas fa-fw fa-folder" icon={faFolder} />
                        <span> Subcategorías</span>
                    </Nav.Link>
                </Nav.Item>
                <Nav.Item className="nav-item" >
                    <Nav.Link eventKey="/admin/notes" href="/admin/notes" className="nav-link">
                        <FontAwesomeIcon className="fas fa-file" icon={faFile} />
                        <span> Release Notes</span>
                    </Nav.Link>
                </Nav.Item>
                <hr className="sidebar-divider" />
                <Nav.Item className="nav-item" >
                    <Nav.Link eventKey="/admin/users" href="/admin/users" className="nav-link">
                        <FontAwesomeIcon className="fas fa-user" icon={faUser} />
                        <span className="nav-text"> Usuarios</span>
                    </Nav.Link>
                </Nav.Item>
            </Nav>
        </>

    )

}

export default withRouter(MenuSider);